import React from "react";
// import 'leaflet/dist/leaflet.css';
// import 'leaflet-editable';
// import 'leaflet-path-drag';
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";

// Light Icons only
import TESTINGTOOL_LIGHT from "../../AeroCapture/assets/toolbar/Testing_Area_Light.svg";
import TRAININGTOOL_LIGHT from "../../AeroCapture/assets/toolbar/Training_Area_Light.svg";
import ACCURACYTOOL_LIGHT from "../../AeroCapture/assets/toolbar/Accuracy_Area_Light.svg";
import DETECTIONTOOL_LIGHT from "../../AeroCapture/assets/toolbar/Detection_Area_Light.svg";
import POLYGONICON_LIGHT from "../../AeroCapture/assets/toolbar/Polygon_Light.svg";
import POLYLINEICON_LIGHT from "../../AeroCapture/assets/toolbar/Line_Light.svg";
import IMPORT_LIGHT from "../../AeroCapture/assets/toolbar/Import_Light.svg";
import EXPORT_LIGHT from "../../AeroCapture/assets/toolbar/Export_Light.svg";
import CIRCLEICON_LIGHT from "../../AeroCapture/assets/toolbar/Circle_Light.svg";
import RECTANGLEICON_LIGHT from "../../AeroCapture/assets/toolbar/Rectangle_Light.svg";
import COMPAREICON_LIGHT from "../../AeroCapture/assets/toolbar/Compare_Light.svg";
import RECENTERICON_LIGHT from "../../AeroCapture/assets/toolbar/Center_Light.svg";
import MARKERICON_LIGHT from "../../AeroCapture/assets/toolbar/Marker_Light.svg";
import POINTERICON_LIGHT from "../../AeroCapture/assets/toolbar/Pointer_Light.svg";
import POINTDETAILSICON_LIGHT from "../../AeroCapture/assets/toolbar/point_detaile_light.png";

const TOOLS = {
  DRAG: "DRAG",
  CENTER: "CENTER",
  POLYGON: "POLYGON",
  RECTANGLE: "RECTANGLE",
  CIRCLE: "CIRCLE",
};

const KEYBOARD_SHORTCUT_LABELS = {
  ESCAPE: ["Esc"],
  POLYGON_TOOL: ["P"],
  RECTANGLE_TOOL: ["R"],
  CIRCLE_TOOL: ["C"],
  CENTER_MAP: ["Space"],
};

const { DRAG, CENTER, POLYGON, RECTANGLE, CIRCLE } = TOOLS;

export default function AnnotationToolbar({
  activeTool,
  onChangeTool,
  defaultDisabled = false,
}) {
    
  const getToolShortcut = (toolId) => {
    let shortcuts;
    switch (toolId) {
      case DRAG:
        shortcuts = KEYBOARD_SHORTCUT_LABELS.ESCAPE;
        break;
      case POLYGON:
        shortcuts = KEYBOARD_SHORTCUT_LABELS.POLYGON_TOOL;
        break;
      case RECTANGLE:
        shortcuts = KEYBOARD_SHORTCUT_LABELS.RECTANGLE_TOOL;
        break;
      case CIRCLE:
        shortcuts = KEYBOARD_SHORTCUT_LABELS.CIRCLE_TOOL;
        break;
      case CENTER:
        shortcuts = KEYBOARD_SHORTCUT_LABELS.CENTER_MAP;
        break;
      default:
        return null;
    }
    return shortcuts ? shortcuts.join(" + ") : null;
  };

  const tools = [
    {
      id: DRAG,
      icon: <img src={POINTERICON_LIGHT} style={{ height: 20, width: 20 }} />,
      label: "Pan",
    },
    {
      id: POLYGON,
      icon: <img src={POLYGONICON_LIGHT} style={{ height: 20, width: 20 }} />,
      label: "Polygon",
      disabled: defaultDisabled,
    },
    {
      id: RECTANGLE,
      icon: <img src={RECTANGLEICON_LIGHT} style={{ height: 20, width: 20 }} />,
      label: "Rectangle",
      disabled: defaultDisabled,
    },
    {
      id: CIRCLE,
      icon: <img src={CIRCLEICON_LIGHT} style={{ height: 20, width: 20 }} />,
      label: "Circle",
      disabled: defaultDisabled,
    },
    {
      id: CENTER,
      icon: <img src={RECENTERICON_LIGHT} style={{ height: 24, width: 24 }} />,
      label: "Center",
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "white",
        border: "1px solid #ddd",
        boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
        padding: "8px 4px",
        borderRadius: "12px",
        justifyContent: "space-evenly",
        height: "fit-content",
      }}
    >
      {tools.map((tool) => {
        const shortcut = getToolShortcut(tool.id);

        return (
          <Tooltip
            key={tool.id}
            title={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 8,
                    fontSize: "12px",
                    fontWeight: 500,
                    color: "#1F1C45",
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  <p style={{ color: "#1F1C45", margin: 0 }}>{tool.label}</p>
                  {shortcut && (
                    <kbd
                      style={{
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        fontSize: "10px",
                        color: "#1F1C45",
                      }}
                    >
                      {shortcut}
                    </kbd>
                  )}
                </div>
              </div>
            }
            placement="right"
            arrow
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#FFFFFF",
                  color: "#1F1C45",
                  boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                  borderRadius: "8px",
                  padding: "6px 8px",
                },
              },
              arrow: {
                sx: {
                  color: "#FFFFFF",
                },
              },
            }}
          >
            <div style={{ width: 32, height: 32 }}>
              <button
                value={tool.id}
                aria-label={tool.label}
                style={{
                  width: "100%",
                  height: "100%",
                  padding: 0,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: "6px",
                }}
                onClick={() => onChangeTool(tool.id)}
                disabled={tool.disabled}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "rgb(41, 137, 207)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                {tool.icon}
              </button>
            </div>
          </Tooltip>
        );
      })}
    </div>
  );
}
